import React from 'react'
import { URL_SRV_ARIZTIA } from '../../router/Url';

export const SaveNowDatosCalderaDiario = (data) => {
    console.log(data);
    return new Promise(async (resolve, reject) => {
		let query = await fetch(URL_SRV_ARIZTIA+ "savedatacalderadiario", {
			method: "POST",
			headers: {
				authorization: "paico2021",
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify(
				data
			),
		});
		let responsito = await query.json();
		console.log(responsito)
		if (responsito.success) {
			resolve(responsito.success);
		} else {
			resolve([]);
		}
	});
}
